module.exports = __webpack_public_path__ + "img/version_banner.d504125.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/version_banner.jpg
// module id = hqiP
// module chunks = 207